import moment from 'moment';
import { formatDate } from '@/utils';

export const useFormattable = () => {
  const toDollarFormat = dollarFloat => {
    let numberString = Number.parseFloat(dollarFloat).toFixed(2);
    let parts = numberString.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `$${parts.join('.')}`;
  };

  const toLocalDate = date => {
    return date ? formatDate(date, 'MM/DD/YYYY') : '';
  };

  const formatDate = (date, format = 'MM/DD/YYYY') => {
    return formatDate(date, format);
  };
  const now = () => {
    return toIso8601Date(new Date());
  };
  const toIso8601Date = (date) => {
    try {
      return formatDate(date, 'YYYY-MM-DD');
    } catch (error) {
      return ''; // whut we doin here?
    }
  };
  const validDate = (date) => {
    return moment(date).isValid();
  };

  return {
    toDollarFormat,
    toLocalDate,
    now,
    toIso8601Date,
    validDate,
  }
};
